import React, { useState, useEffect, useRef } from "react";
import HighlightBlock from "./HighlightBlock";

export default function PlansShowcaseMilestoneSimple({
    plans,
    title = "Doğayla iç içe nefes alan yaşam alanları",
    desc = "",
    highlightBlockProps = {},
    autoInterval = 5000,
}) {
    const [active, setActive] = useState(0);
    const [progress, setProgress] = useState(0);
    const timerRef = useRef();

    const prev = () => setActive((prev) => (prev === 0 ? plans.length - 1 : prev - 1));
    const next = () => setActive((prev) => (prev === plans.length - 1 ? 0 : prev + 1));

    useEffect(() => {
        if (plans.length <= 1) return;
        setProgress(0);
        timerRef.current && clearInterval(timerRef.current);
        let start = Date.now();

        timerRef.current = setInterval(() => {
            const elapsed = Date.now() - start;
            const percent = Math.min(100, (elapsed / autoInterval) * 100);
            setProgress(percent);
            if (percent >= 100) {
                setActive((current) => (current === plans.length - 1 ? 0 : current + 1));
                start = Date.now();
                setProgress(0);
            }
        }, 20);

        return () => clearInterval(timerRef.current);
    }, [active, plans.length, autoInterval]);

    const handlePrev = () => {
        prev();
        setProgress(0);
    };
    const handleNext = () => {
        next();
        setProgress(0);
    };

    return (
        <section className="plans-milestone-wrap">
            <div className="container">
                <HighlightBlock {...highlightBlockProps}>
                    <div className="row align-items-center plans-milestone-row gx-5 flex-row-reverse">

                        <div className="col-lg-6 plans-milestone-text">
                            <h2 className="plans-milestone-title">{title}</h2>
                            <div className="plans-milestone-desc">{desc}</div>
                            {plans.length > 1 && (
                                <div className="plans-milestone-arrows mt-4">
                                    <button className="arrow-btn" onClick={handlePrev} aria-label="Önceki">
                                        <i className="fa fa-chevron-left" />
                                    </button>
                                    <button className="arrow-btn" onClick={handleNext} aria-label="Sonraki">
                                        <i className="fa fa-chevron-right" />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="col-lg-6 plans-milestone-visuals d-flex flex-column align-items-center">
                            <div className="plans-milestone-main-img w-100">
                                <img src={plans[active].img} alt={plans[active].title || ""} />
                            </div>
                            {plans.length > 1 && (
                                <div className="plans-milestone-progress-bar-wrap">
                                    <div className="plans-milestone-progress-bar">
                                        <div
                                            className="plans-milestone-progress-bar__fill"
                                            style={{ width: `${progress}%` }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </HighlightBlock>
            </div>
        </section>
    );
}
